export default __webpack_public_path__ + "images/25c82dc950839b0edad1c2c1f9896681.svg";